import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";

export interface WorkshopProductCombination {
    id?: number,
    guid?: string | null,
    testCombinationId: number,
    workshopProductId: number,
    isProvider: boolean,
    isConsumer: boolean,
    providerReadyToTest: boolean,
    consumerReadyToTest: boolean,
    updateErrorReason?: string
}

export interface WSProdConfigCounters {
    testCaseSum: number,
    testCaseMarked: number,
    workshopProductCombinationId: number
}

export interface WSProdConfigAllReady {
    workshopProductId: number,
    setReadyToTest: boolean
}

export const GetEmptyWSPTC = () => {
    let wsptc: WorkshopProductCombination = {
        testCombinationId: 0,
        workshopProductId: 0,
        isProvider: false,
        isConsumer: false,
        providerReadyToTest: false,
        consumerReadyToTest: false
    }
    return wsptc;
}

export const getWSProdConfigCounters = (workshopid: number, abortController: AbortController): Promise<ApiResponse<WSProdConfigCounters[]>> =>
    httpGet(`/api/workshopproduct/getwsprodconfigcounters/${workshopid}`, abortController);

export const getWSProductCombinations = (workshopid: number, abortController: AbortController): Promise<ApiResponse<WorkshopProductCombination[]>> =>
    httpGet(`/api/workshopproduct/getwsproductcombinations/${workshopid}`, abortController);
export const getProductCombinations = (workshopProductId: number, abortController: AbortController): Promise<ApiResponse<WorkshopProductCombination[]>> =>
    httpGet(`/api/workshopproduct/getproductcombinations/${workshopProductId}`, abortController);
export const updateProdTestCombination = (data: WorkshopProductCombination, abortController: AbortController): Promise<ApiResponse<WorkshopProductCombination>> =>
    httpPost(`/api/workshopproduct/updateproductcombination`, data, abortController);
export const setAllProdTestCombination = (data: WSProdConfigAllReady, abortController: AbortController): Promise<ApiResponse<WorkshopProductCombination[]>> =>
    httpPost(`/api/workshopproduct/updateallproductcombinations`, data, abortController);
export const deleteProdTestCombination = (wsprodcombinationid: number, abortController: AbortController): Promise<ApiResponse<WorkshopProductCombination>> =>
    httpGet(`/api/workshopproduct/deleteproductcombination/${wsprodcombinationid}`, abortController);
